import { useRouter } from "next/router";
import React from "react";

let loaded = false;

export const initializeRouterState = {
  isRouterInitializing: false
};

export const useInitializeRouter = () => {
  const router = useRouter();

  React.useEffect(() => {
    if (!loaded) {
      setTimeout(() => {
        initializeRouterState.isRouterInitializing = true;
        router.replace(window.location.pathname + window.location.search, undefined, {
          scroll: false,
          shallow: false
        });
        setTimeout(() => {
          initializeRouterState.isRouterInitializing = false;
        }, 50);
      }, 500);
      loaded = true;
    }
  }, [router]);
};
